import React, { useEffect } from 'react'
// import logo from './logo.svg'
import ScrollToTop from './components/ScrollToTop'
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
// import Shops from './pages/Shops'
import Card from './pages/Card'
import Shipping from './pages/Shipping'
import Details from './pages/Details'
import Login from './pages/Login'
import Register from './pages/Register'
import RegisterCode from './pages/RegisterCode'
import EmailVerificationPage from './pages/EmailVerificationPage'
import { get_category } from './store/reducers/homeReducer'
import { useDispatch } from 'react-redux'
import CategoryShop from './pages/CategoryShop'
import SearchProducts from './pages/SearchProducts'
import Payment from './pages/Payment'
import Dashboard from './pages/Dashboard'
import ProtectUser from './utils/ProtectUser'
import Index from './components/dashboard/Index'
import Orders from './components/dashboard/Orders'
import ChangePassword from './components/dashboard/ChangePassword'
import Wishlist from './components/dashboard/Wishlist'
import OrderDetails from './components/dashboard/OrderDetails'
import Chat from './components/dashboard/Chat'
import ConfirmOrder from './pages/ConfirmOrder'
import { getCurrentTime } from './utils/timeConvertor'
import moment from 'moment'
import Categories from './pages/Categories'
import { get_currencyIQD } from './store/reducers/dashboardReducer'
import { get_discount_products } from './store/reducers/homeReducer'
import { socket } from './utils/utils'
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton'
import AboutUs from './pages/AboutUs'
import Profile from './components/dashboard/Profile'
import ForgotPassword from './pages/ForgotPassword'
import ContactUS from './pages/ContactUs'

function App() {
  const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(get_category())
  //   dispatch(get_currencyIQD()) // Fetch currency here
  // }, [dispatch])

  useEffect(() => {
    // Dispatch the initial fetch
    dispatch(get_category())
    dispatch(get_currencyIQD())

    // Socket listener for currency updates
    const handleCurrencyUpdate = (data) => {
      dispatch(get_currencyIQD())
    }
    const handleProductUpdate = (data) => {
      dispatch(get_discount_products())
    }

    socket.on('currencyUpdate', handleCurrencyUpdate)
    socket.on('productUpdate', handleProductUpdate)

    return () => {
      socket.off('currencyUpdate', handleCurrencyUpdate)
    }
  }, [dispatch])

  useEffect(() => {
    const cleanupLocalStorage = () => {
      const currentTime = getCurrentTime()
      const recentProducts =
        JSON.parse(localStorage.getItem('recentProducts')) || []

      const validProducts = recentProducts.filter((item) => {
        const itemTime = moment(
          item.timestamp,
          'DD-MM-YYYY HH:mm:ss',
        ).utcOffset('+03:00')

        const currentMoment = moment(
          currentTime,
          'DD-MM-YYYY HH:mm:ss',
        ).utcOffset('+03:00')
        return currentMoment.diff(itemTime, 'hours') <= 24
      })

      localStorage.setItem('recentProducts', JSON.stringify(validProducts))
    }

    cleanupLocalStorage()

    const cleanupInterval = setInterval(cleanupLocalStorage, 60 * 60 * 1000)

    return () => clearInterval(cleanupInterval)
  }, [])

  return (
    <BrowserRouter>
      <ScrollToTop />
      <WhatsAppFloatingButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registerCode" element={<RegisterCode />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/" element={<EmailVerificationPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about_us" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUS />} />
        <Route path="/card" element={<Card />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/products?" element={<CategoryShop />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/products/search?" element={<SearchProducts />} />
        <Route path="/product/details/:slug" element={<Details />} />
        <Route path="/order/confirm?" element={<ConfirmOrder />} />

        <Route path="/dashboard" element={<ProtectUser />}>
          <Route path="" element={<Dashboard />}>
            <Route path="" element={<Index />} />
            <Route path="my-orders" element={<Orders />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="profile" element={<Profile />} />
            <Route path="my-wishlist" element={<Wishlist />} />
            <Route path="order/details/:orderId" element={<OrderDetails />} />
            <Route path="chat" element={<Chat />} />
            <Route path="chat/:sellerId" element={<Chat />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
